import { useActivation } from '@context/MobileOne';
import { FeedbackImage, ScrollToTop } from '@core/index';
import { replaceDynamicCmsContent, tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIconsPath } from '@utils/globalConstant';
import useCmsImage from '@utils/useCmsImage';

export const LegitimationSuccess = () => {
  const { nextStep, setShowActivationHeader, setStep6SubStep, personalDataForm } = useActivation();

  // Const
  let imageContent = useCmsImage('ek_reg_legi_suc_web_bg');
  const headerContent = replaceDynamicCmsContent(
    tA11y('ek_reg_choose_legi_feedback_hdl1'),
    '{LEGITIMATION_NAME}',
    `${personalDataForm.legitimationName}`
  );
  const copyTextContent = replaceDynamicCmsContent(
    tA11y('ek_reg_choose_legi_feedback_txt1'),
    '{LEGITIMATION_NAME}',
    `${personalDataForm.legitimationName}`
  );
  const buttonContent = tA11y('ek_reg_choose_legi_feedback_btn1');

  return (
    <>
      <ScrollToTop>
        <FeedbackImage
          image={imageContent}
          icon={appIconsPath.INFO_MESSAGE}
          headingContent={headerContent}
          copyTextContent={copyTextContent}
          buttonContent={buttonContent}
          buttonType={appButtonType.PRIMARY}
          buttonIcon={appIconsPath.ARROW_RIGHT}
          buttonClick={() => {
            setStep6SubStep(0);
            nextStep();
            setShowActivationHeader(true);
          }}
        />
      </ScrollToTop>
    </>
  );
};

export default LegitimationSuccess;
